export default "__VITE_ASSET__DMiQW8yZ__"